import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickContactCard = ({ departments }) => {
  const quickContacts = [
    {
      title: 'สายด่วนฉุกเฉิน',
      phone: '191',
      description: 'แจ้งเหตุฉุกเฉิน 24 ชั่วโมง',
      icon: 'Phone',
      color: 'bg-error text-error-foreground'
    },
    {
      title: 'ศูนย์บริการประชาชน',
      phone: '02-123-4567',
      description: 'สอบถามข้อมูลทั่วไป',
      icon: 'Headphones',
      color: 'bg-primary text-primary-foreground'
    },
    {
      title: 'แจ้งเรื่องร้องเรียน',
      phone: '02-123-4568',
      description: 'รับเรื่องร้องเรียนและข้อเสนอแนะ',
      icon: 'MessageSquare',
      color: 'bg-secondary text-secondary-foreground'
    }
  ];

  const handleCall = (phone) => {
    window.open(`tel:${phone}`, '_self');
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="PhoneCall" size={20} className="text-primary" />
        <h3 className="text-lg font-medium text-foreground">
          ติดต่อด่วน
        </h3>
      </div>
      <div className="space-y-3">
        {quickContacts?.map((contact, index) => (
          <div key={index} className="border border-border rounded-lg p-4 hover:shadow-government transition-government">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${contact?.color}`}>
                  <Icon name={contact?.icon} size={18} />
                </div>
                <div>
                  <h4 className="font-medium text-foreground text-sm">
                    {contact?.title}
                  </h4>
                  <p className="text-xs text-muted-foreground mb-1">
                    {contact?.description}
                  </p>
                  <p className="text-sm font-mono text-primary">
                    {contact?.phone}
                  </p>
                </div>
              </div>
              <button
                onClick={() => handleCall(contact?.phone)}
                className="px-3 py-2 bg-primary text-primary-foreground rounded-md text-sm hover:bg-primary/90 transition-government flex items-center space-x-1"
              >
                <Icon name="Phone" size={14} />
                <span>โทร</span>
              </button>
            </div>
          </div>
        ))}
      </div>
      {/* Office Hours */}
      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center space-x-2 mb-3">
          <Icon name="Clock" size={16} className="text-primary" />
          <h4 className="font-medium text-foreground">เวลาทำการ</h4>
        </div>
        <div className="text-sm text-muted-foreground space-y-1">
          <p>วันจันทร์ - วันศุกร์: 08:30 - 16:30 น.</p>
          <p>วันเสาร์ - วันอาทิตย์: ปิดทำการ</p>
          <p className="text-xs text-primary mt-2">
            * ยกเว้นวันหยุดราชการ
          </p>
        </div>
      </div>
    </div>
  );
};

export default QuickContactCard;